var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('label',[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"custom-file"},[_c('input',{staticClass:"custom-file-input",attrs:{"id":"fileUpload","type":"file","placeholder":_vm.placeholder}}),_c('label',{staticClass:"custom-file-label",attrs:{"for":"fileUpload"}},[_vm._v("Choose file")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }